import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import CloseIcon from "../Icons/CloseIcon";

import styles from "./view.module.scss";

class View extends React.Component {
  static propTypes = {
    carouselProps: PropTypes.object,
    index: PropTypes.number
  };

  state = {
    captionIsOpen: false
  };

  toggleCaption = () => {
    this.setState({
      captionIsOpen: !this.state.captionIsOpen
    });
  };

  render() {
    const {captionIsOpen} = this.state;
    const {
      carouselProps: {views, onClose, captionRender},
      index
    } = this.props;

    const currentView = views[index];
    return (
      <div className={styles.wrapper} onClick={onClose}>
        <div className={styles.root}>
          <div
            className={classNames(
              styles.view,
              `lightbox-view`,
              currentView.captionContent && styles.hasCaption
            )}
          >
            {currentView.source && <img loading="lazy" src={currentView.source} />}
            {currentView.captionContent && (
              <div
                className={classNames(
                  styles.caption,
                  captionIsOpen && styles.captionOpen
                )}
                onClick={this.toggleCaption}
              >
                {captionRender(currentView)}
              </div>
            )}
          </div>
          <button className={styles.close}>
            <CloseIcon />
          </button>
        </div>
      </div>
    );
  }
}

export default View;
